<template>
  <div class="registration-footer">
    <div class="legal">
      <div id="copyright">
        <p>©1997-2017 LogMeIn, Inc. All rights reserved.</p>
        <p>View the
          <a href="http://www.gotomeeting.com/fec/privacyPopUp?#g2w_pop" rel="external">GoTo Webinar Privacy Policy</a>.</p>
      </div>
      <div id="privacyNotice">
        <p>To review the webinar organizer's privacy policy or opt out of their other communications, contact the webinar organizer directly.</p>
        <p>Safeguarding your email address and webinar registration information is taken seriously at GoTo Webinar. GoTo Webinar will not sell or rent this information.</p>
      </div>
    </div>
  </div>
</template>

<script>
const RegistrationFooter = {
  name: 'RegistrationFooter'
};

export default RegistrationFooter;
</script>

<style scoped lang="sass">
  .registration-footer
    width: 100%
    text-align: center
    font-size: 12px
    color: #aaa

    .legal
      margin: 5px 0px

    p
      margin-bottom: 3px
</style>
